import STATES from '../app/constant/states';
export const environment = {
  home: "https://rudevops.com",
  production: true,
  apiUrl: 'https://saas.restoreunited.com:81', // Connecting to Prod for Testing in Stage
  states: STATES,
  stripe_api_key : "pk_test_0WgUbxQ7lFquVeBjBB8cY4ld00jua9T2Dv"
};
